<template>
  <div>
    <!-- <RealTime/> -->
    <div
      class="notications xatoliklar alert-danger"
      style="z-index: 5"
      v-if="$store.state.project_date != ''"
    >
      <button
        type="button"
        aria-hidden="true"
        class="close"
        @click="$store.state.project_date = ''"
      >
        ×
      </button>
      <p><i class="fas fa-exclamation-triangle"></i>&nbsp; Хатолик</p>
      <div>{{ $store.state.project_date }}</div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
// import RealTime from "./components/RealTime.vue"
export default {
  components: {
    // RealTime
  },
  mounted() {
    
    // setInterval(() => {
    //   if (this.$store.state.project_date != "") {
    //     this.$store.state.project_date = "";
    //   }
    // }, 5000);
  },
  provide() {
    return {
      // local
      // BASE_URL: `http://localhost:3001/api/v1/admin-app/`

      /// biomed
      BASE_URL: "http://82.148.5.250:3003/api/v1/admin-app/a4/"
      // "http://185.76.13.223:4027/api/v1/admin-app/a4/"

    };
  }
};
</script>
<style>
* {
  box-sizing: border-box;
}
.xatoliklar {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* background: rgb(255, 0, 0); */
  padding: 5px 10px;
  border-radius: 10px;
  cursor: pointer;
  opacity: 0;
  animation: animateAlert 3s linear;
  pointer-events: all;
}
</style>
